window.addEventListener('load', () => {
    const publicationEls = document.querySelectorAll('.publications li');

    if (publicationEls.length) {
        gsap.fromTo(publicationEls, {
            yPercent: 20,
        }, {
            yPercent: 0,
            autoAlpha: 1,
            stagger: 0.1,
            translateY: 0,
            scrollTrigger: '.publications'
        });
    }

    const publications = document.querySelectorAll('.publications a');

    publications.forEach(publication => {
        publication.addEventListener('mouseenter', () => {
            let activeImage = document.querySelector('.publication-image.active');
            let newImage = document.getElementById(`publication-${publication.dataset.id}`);

            publications.forEach(el => el.classList.remove('active'));
            publication.classList.add('active');

            if (activeImage) {
                activeImage.classList.remove('active');
            }

            if (newImage) {
                newImage.classList.add('active');

                gsap.fromTo(newImage, {
                    autoAlpha: 0,
                }, {
                    autoAlpha: 1,
                    onComplete() {
                        if (activeImage) {
                            activeImage.style.opacity = 0;
                        }
                    },
                });
            } else if (activeImage) {
                gsap.to(activeImage, {
                    autoAlpha: 1,
                });
            }
        });

        publication.addEventListener('click', e => {
            e.preventDefault();
        });
    });
});
